// Initial state
const initialState = {
  userData: null,
  isAuthenticated: false,
  loading: false,
  error: null
};

// Action types
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';
export const REHYDRATE = 'persist/REHYDRATE';

// Reducer
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return {
        ...state,
        userData: action.payload,
        isAuthenticated: true,
        loading: false,
        error: null
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case CLEAR_USER_DATA:
      return {
        ...initialState
      };
    case REHYDRATE:
      // Handle rehydration of persisted state
      if (action.payload && action.payload.user) {
        return {
          ...state,
          ...action.payload.user
        };
      }
      return state;
    default:
      return state;
  }
};

export default userReducer; 